export default __webpack_public_path__ + "static/media/ab-img.29856996.webp";